import { Form, Button, Row, Col } from 'react-bootstrap'
import { Formik } from 'formik'
import * as yup from 'yup'
import classNames from 'classnames'
import FormError from '../FormError/FormError'
import React from 'react'
import styles from './SupportForm.module.scss'

const SupportForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    privacy: yup.bool().required().oneOf([true], 'Required'),
    terms: yup.bool().required().oneOf([true], 'Required')
  })

  const handleSubmit = async () => {
    if (onSubmit) {
      // Without await, Submit button does not disable because isSubmitting instantly
      // turns to false.
      await onSubmit()
    }
  }

  return (
    <div className={styles.supportFormContainer}>
      <Formik
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={handleSubmit}
        initialValues={{
          terms: false,
          privacy: false
        }}
      >
        {({ handleSubmit, handleChange, errors, isSubmitting }) => (
          <Form noValidate onSubmit={handleSubmit} className={'pb-3'}>
            <FormError errors={errors} />
            <Row>
              <Form.Group as={Col} className={'mb-3'} controlId="termsFormItem">
                <Form.Check
                  custom
                  type={'checkbox'}
                  name={'terms'}
                  value={true}
                  className={classNames('sm')}
                  id={`terms`}
                >
                  <Form.Check.Input onChange={handleChange} required isInvalid={!!errors.terms} />
                  <Form.Check.Label>
                    <CheckboxLabel
                      title={'Samsung Partner Portal Terms and Conditions'}
                      url={'https://partnerhub.samsung.com/SVCPartnerSsoTnc'}
                    />
                  </Form.Check.Label>
                </Form.Check>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="privacyFormItem">
                <Form.Check
                  custom
                  type={'checkbox'}
                  name={'privacy'}
                  value={true}
                  className={classNames('sm')}
                  id={`privacy`}
                >
                  <Form.Check.Input onChange={handleChange} required isInvalid={!!errors.privacy} />
                  <Form.Check.Label>
                    <CheckboxLabel
                      title={'Samsung B2B Privacy Policy'}
                      url={'https://partnerhub.samsung.com/SVCPartnerSsoPrivacy'}
                    />
                  </Form.Check.Label>
                </Form.Check>
              </Form.Group>
            </Row>
            <Button type="submit" disabled={isSubmitting} className="mt-4">
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}
const CheckboxLabel = ({ title, url }) => {
  return (
    <span>
      I have read and agree to the{' '}
      <a href={url} target={'_blank'} rel={'noreferrer'}>
        {title}
      </a>
      .
    </span>
  )
}

export default SupportForm
